export const REMOVE_REQUEST_TO_REFRESH_DG_RELATED_ENTITIES = 'REMOVE_REQUEST_TO_REFRESH_DG_RELATED_ENTITIES';

export interface RemoveRequestToRefreshDgRelatedEntitiesAction {
  type: typeof REMOVE_REQUEST_TO_REFRESH_DG_RELATED_ENTITIES;
}

export const removeRequestToRefreshDgRelatedEntitiesAction = ()
  : RemoveRequestToRefreshDgRelatedEntitiesAction =>
  ({ type: REMOVE_REQUEST_TO_REFRESH_DG_RELATED_ENTITIES });
